import CardElementConfiguration from './CardElementConfiguration';

export default CardElementConfiguration;
